module.exports = __webpack_public_path__ + "static/media/imgEligibilitySorry.60e1a971.png";